<template>
  <app-layout>
    <template v-slot:header>
      <Header :title="$t('my_mentora_request')"
              :isFilter="false">
      </Header>
    </template>
    <template v-slot:header-mobile>
      <HeaderMobile :title="$t('my_mentora_request')"
                    :isFilter="false">
      </HeaderMobile>
    </template>
    <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
      <div class="tabs-bottom-line"></div>
      <b-tab v-if="checkPermission('changeofclassrequest_index')">
        <div class="d-flex justify-content-end mb-2">
          <b-button
              variant="primary"
              class="mr-2"
              @click="$router.push('/esl/change-of-class/request-form')"
          >
            {{ $t('new_request') }}
          </b-button>
        </div>
        <template #title><span class="d-flex align-items-center">{{ $t('esl_change_of_class_request') }}</span>
        </template>
        <ChangeOfClassRequest :filter="filter" v-if="tabIndex === indexes.changeOfClassRequest"/>
      </b-tab>
      <b-tab v-if="checkPermission('studenttimeoffrequest_index')">
        <div class="d-flex justify-content-end mb-2">
          <b-button
              variant="primary"
              class="mr-2"
              @click="$router.push('/mentora/time/off/request-form')"
          >
            {{ $t('new_request') }}
          </b-button>
        </div>
        <template #title><span class="d-flex align-items-center">{{ $t('time_off') }}</span>
        </template>
        <TimeOfRequest :filter="filter" v-if="tabIndex===indexes.timeOffRequest"/>
      </b-tab>
      <b-tab v-if="checkPermission('transferoutrequest_index')">
        <div class="d-flex justify-content-end mb-2">
          <b-button
              variant="primary"
              class="mr-2"
              @click="$router.push('/mentora/transfer/out-request')"
          >
            {{ $t('new_request') }}
          </b-button>
        </div>
        <template #title><span class="d-flex align-items-center">{{ $t('transfer_out') }}</span>
        </template>
        <TransferOut :filter="filter" v-if="tabIndex===indexes.transferOutRequest"/>
      </b-tab>
      <b-tab v-if="checkPermission('studentoutofcountryrequest_studentindex')" tabindex="3">
        <div class="d-flex justify-content-end mb-2">
          <b-button
              variant="primary"
              class="mr-2"
              @click="$router.push('/mentora/out/of/country/request-form')"
          >
            {{ $t('new_request') }}
          </b-button>
        </div>
        <template #title><span class="d-flex align-items-center">{{ $t('out_of_country_request') }}</span>
        </template>
        <OutOfCountryRequest :filter="filter" v-if="tabIndex===indexes.outOfCountryRequest"/>
      </b-tab>
      <b-tab v-if="checkPermission('documentrequest_student')">
        <template #title><span class="d-flex align-items-center">Transcript/Certificate/Status Letter</span>
        </template>
        <DocumentRequest :filter="filter" v-if="tabIndex===indexes.documentRequest"/>
      </b-tab>
    </b-tabs>
  </app-layout>
</template>
<script>
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"
import ChangeOfClassRequest from "@/modules/studentProgram/pages/myMentoraRequest/components/ChangeOfClassRequest.vue";
import TimeOfRequest from "@/modules/studentProgram/pages/myMentoraRequest/components/TimeOfRequest.vue";
import TransferOut from "@/modules/studentProgram/pages/myMentoraRequest/components/TransferOut.vue";
import OutOfCountryRequest from "@/modules/studentProgram/pages/myMentoraRequest/components/OutOfCountryRequest.vue";
import DocumentRequest from "@/modules/studentProgram/pages/myMentoraRequest/components/DocumentRequest.vue";

export default {
  components: {
    DocumentRequest,
    TransferOut,
    TimeOfRequest,
    ChangeOfClassRequest,
    OutOfCountryRequest,
    AppLayout,
    Header,
    HeaderMobile,
  },
  data() {
    return {
      tabIndex: 0,
      filter: {},
      slots: null,
      selectedCourseTransfer: null,
      studentApproveForm: {},
      stateData: {},
      indexes:{
        changeOfClassRequest:0,
        timeOffRequest:1,
        transferOutRequest:2,
        outOfCountryRequest:3,
        documentRequest:4,
      }
    }
  },
  metaInfo() {
    return {
      title: this.$t("my_mentora_request")
    }
  },
  methods: {
    loadData() {
      if (!this.stateData || !this.stateData.active_student_program) {
        return;
      }
      this.filter = {
        params: {
          student_program_id: this.stateData.active_student_program.id
        }
      }
    },
  },
  created() {
    this.$store.dispatch("auth/initUser");
    this.stateData = {
      ...this.$store.getters['auth/getUser']
    }

    if(!this.checkPermission('changeofclassrequest_index')){
      this.indexes.changeOfClassRequest=-1;
      this.indexes.timeOffRequest=0;
      this.indexes.transferOutRequest=1;
      this.indexes.outOfCountryRequest=2;
      this.indexes.documentRequest=3;
    }
    if(!this.checkPermission('studenttimeoffrequest_index')){
      this.indexes.timeOffRequest=-1;
      this.indexes.transferOutRequest--;
      this.indexes.outOfCountryRequest--;
      this.indexes.documentRequest--;
    }
    if(!this.checkPermission('transferoutrequest_index')){
      this.indexes.transferOutRequest=-1;
      this.indexes.outOfCountryRequest--;
      this.indexes.documentRequest--;
    }
    if(!this.checkPermission('studentoutofcountryrequest_studentindex')){
      this.indexes.outOfCountryRequest=-1;
      this.indexes.documentRequest--;
    }
    if(!this.checkPermission('documentrequest_student')){
      this.indexes.documentRequest=-1;
    }

    if (this.$route.params.tab) {
      this.tabIndex = parseInt(this.$route.params.tab)
    }

    this.loadData();
  },
}
</script>

<style lang="scss">
.document_request_dropdown {
  tr {
    td:first-child {
      padding-right: 0px !important;
    }
  }
}
</style>
